export const OFFERINGS_FOR_PARTNERS = [
  {
    description:
      'A VIP membership that gives you access to The Information’s community, Pro content, and exclusive events',
    imageSrc: 'partners/brand-partnerships-corporate-subscriber-circle.png',
    imageAltText:
      'Corporate Subscriber Circle screenshot, featuring Vauban from Carta, TapOnIt, and other companies',
    title: 'The Information Subscriber Council',
  },
  {
    description:
      'Prominent brand messaging across The Information articles, app, homepage and emails',
    imageSrc: 'partners/brand-partnerships-featured-partnership.png',
    imageAltText: 'A Featured Partnership on The Information homepage',
    title: 'Featured Partnerships',
  },
  {
    description:
      'Full takeovers of Weekend, Creator Economy, Crypto Global and our other highly influential newsletters',
    imageSrc: 'partners/brand-partnerships-newsletter-sponsorship.png',
    imageAltText: 'A screenshot of what a sponsored newsletter takeover might look like',
    shouldHaveBoxShadow: false,
    title: 'Newsletter Sponsorships',
  },
  {
    description:
      'Integration into annual specials like the Creator Economy Database and the Tech IPO tracker',
    imageSrc: 'partners/brand-partnerships-editorial-sponsorship.png',
    imageAltText: 'A screenshot of a special sponsorship of a tentpole editorial project',
    title: 'Editorial Special Sponsorships',
  },
  {
    description:
      'Co-host events like WTF (Women in Tech and Finance) and custom roundtables with industry leaders',
    imageSrc: 'partners/brand-partnerships-event-sponsor.jpg',
    imageAltText: 'A roundup of sponsors for the 2023 WTF event',
    title: 'Event Sponsorships',
  },
];
